import { render } from "./ReviewCard.vue?vue&type=template&id=7a8bd8ff&scoped=true&ts=true"
import script from "./ReviewCard.vue?vue&type=script&lang=ts"
export * from "./ReviewCard.vue?vue&type=script&lang=ts"

import "./ReviewCard.vue?vue&type=style&index=0&id=7a8bd8ff&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8bd8ff"]])

export default __exports__